import { render, staticRenderFns } from "./SupplierListTable.vue?vue&type=template&id=f27cca50"
import script from "./SupplierListTable.vue?vue&type=script&lang=js"
export * from "./SupplierListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports